import React from 'react';

import Header from '../components/Header'
import Navigation from '../components/Navigation';
import Incidents from '../components/incidents/Incidents';

function IncidentsPage() {
  return (
    <>
        <Header />
        <div className="page-with-nav">
            <Navigation />
            <Incidents />
        </div>
    </>
  )
}

export default IncidentsPage;